import { render } from "./ItemVoidedReport.vue?vue&type=template&id=2423c4c4&scoped=true"
import script from "./ItemVoidedReport.vue?vue&type=script&lang=js"
export * from "./ItemVoidedReport.vue?vue&type=script&lang=js"

import "./ItemVoidedReport.vue?vue&type=style&index=0&id=2423c4c4&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2423c4c4"]])

export default __exports__